import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
    return (
        <div className="bg-white dark:bg-gray-900 min-h-[60vh] flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-gray-900 dark:text-white">404</h1>
                <p className="mt-4 text-xl text-gray-600 dark:text-gray-400">Page not found</p>
                <p className="mt-2 text-gray-500 dark:text-gray-500">
                    Sorry, we couldn't find the page you're looking for.
                </p>
                <div className="mt-6">
                    <Link
                        to="/"
                        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                    >
                        Go back home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
